
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const THIRD_PARTY_TEXT = 'HomeGauge (that\'s us) is a 3<sup>rd</sup> party in the property inspection report process. '
  + 'It is utilized by your residential or commercial inspector to record and store your information and inspection report(s). '
  + 'Your information will be kept private unless your inspector has offered you another program as a benefit to you.';

const state = {
  inspection: {},
  inspectionError: null,
  inspections: [],
  thirdPartyText: THIRD_PARTY_TEXT,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
